// src/api/service/admin_projects.service.ts
import { apiClient } from "../../config";
import { env } from "../../../config/env";
import {
  GetProjectsResponse,
  GetProjectResponse,
  SuccessResponse,
  CreateProjectPayload,
  UpdateProjectPayload,
} from "../../interface/projects.interface";

class AdminProjectsService {
  /**
   * 📦 GET ALL PROJECTS
   */
  async getProjects(): Promise<GetProjectsResponse> {
    const response = await apiClient.get<GetProjectsResponse>(
      env.ADMIN_PROJECTS_URL
    );
    return response.data;
  }

  /**
   * 📄 GET ONE PROJECT
   */
  async getProject(id: string): Promise<GetProjectResponse> {
    const response = await apiClient.get<GetProjectResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}`
    );
    return response.data;
  }

  /**
   * ➕ CREATE PROJECT (multipart/form-data)
   */
  async createProject(formData: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post<SuccessResponse>(
      env.ADMIN_PROJECTS_URL,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  /**
   * ✏️ UPDATE PROJECT (JSON)
   */
  async updateProject(id: string, payload: UpdateProjectPayload): Promise<SuccessResponse> {
    const response = await apiClient.put<SuccessResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}`,
      payload
    );
    return response.data;
  }

  /**
   * 🖼️ UPDATE THUMBNAIL
   */
  async updateThumbnail(id: string, file: File): Promise<SuccessResponse> {
    const formData = new FormData();
    formData.append("thumbnail", file);
    const response = await apiClient.post<SuccessResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}/thumbnail`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  /**
   * 🖼️ UPLOAD GALLERY (max 5 images)
   */
  async uploadGallery(id: string, files: File[]): Promise<SuccessResponse> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("gallery[]", file);
    });
    const response = await apiClient.post<SuccessResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}/gallery`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  }

  /**
   * 🗑️ DELETE GALLERY IMAGE BY INDEX
   */
  async deleteGalleryImage(id: string, index: number): Promise<SuccessResponse> {
    const response = await apiClient.delete<SuccessResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}/gallery/${index}`
    );
    return response.data;
  }

  /**
   * 🗑️ DELETE PROJECT
   */
  async deleteProject(id: string): Promise<SuccessResponse> {
    const response = await apiClient.delete<SuccessResponse>(
      `${env.ADMIN_PROJECTS_URL}/${id}`
    );
    return response.data;
  }
}

export const adminProjectsService = new AdminProjectsService();